import React from 'react';
import { Box } from '@material-ui/core';
import DealerMenuButton from './DealerMenuButton';
import Support from './Support';

export default function TopBarAddOn() {
  return (
    <Box display="inline-flex" alignItems="center">
      <DealerMenuButton />
      <Support />        
    </Box>
  )
}
